import React, {useState} from 'react';
import EditProductModal from './modals/EditProductModal';
import DeleteProductModal from './modals/DeleteProductModal';
import moment from 'moment';

const ProductListItem = ({product, refreshList}) => {
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const convertDateString = (date) => {
        return moment(date).format('MM/DD/YYYY hh:mm');
    };

    const toggleEditModal = () => setEditModalOpen(prevState => !prevState);
    const toggleDeleteModal = () => setDeleteModalOpen(prevState => !prevState);

    return (
        <tr className="table_row">
            {editModalOpen && (
                <EditProductModal
                    isOpen={editModalOpen}
                    toggle={toggleEditModal}
                    product={product}
                    refreshList={refreshList}
                />
            )}
            {deleteModalOpen && (
                <DeleteProductModal
                    isOpen={deleteModalOpen}
                    toggle={toggleDeleteModal}
                    product={product}
                    refreshList={refreshList}
                />
            )}
            <td className="table_column">
                <strong className="table_lable">Product</strong>
                <div className="table-title_container">
                    <span>{product.name}</span>
                </div>
            </td>

            <td className="table_column">
                <strong className="table_lable">Created At</strong>
                {convertDateString(product.createdAt)}
            </td>
            <td className="table_column">
                <strong className="table_lable">Users</strong>
                {product.countOfUser}
            </td>
            <td className="table_column column_action">
                <strong className="table_lable">Actions</strong>
                <div style={{width: '60px', display: 'flex'}}>
                    <i style={{cursor: 'pointer', padding: '5px'}}
                       className="fas fa-pencil-alt mr-2"
                       onClick={toggleEditModal}/>
                    <i style={{cursor: 'pointer', padding: '5px'}}
                       className="fas fa-trash-alt"
                       onClick={toggleDeleteModal}
                       title="Delete User"
                    />
                </div>
            </td>
        </tr>
    );
};

export default ProductListItem;